import { userContext } from '../userManager';
import { getStartAndEndDateByTag } from '../../utils/dates';

export const apiPortfolioProposalsKpisGet = (proposalId, startDate, endDate) =>
  userContext.apiCall({
    url: `/portfolio-proposals/${proposalId}/kpis?startDate=${startDate ?? ''}&endDate=${
      endDate ?? ''
    }`,
  });

export const apiPortfolioProposalsDetailsGet = (proposalId) =>
  userContext.apiCall({
    url: `/portfolio-proposals/${proposalId}`,
  });

export const apiPortfolioProposalsHoldingsGet = (proposalId) =>
  userContext.apiCall({
    url: `/portfolio-proposals/${proposalId}/proposal-holdings`,
  });

export const apiPortfolioProposalsHoldingsPatch = (proposalId, holdings) =>
  userContext.apiCall({
    url: `/portfolio-proposals/${proposalId}/proposal-holdings`,
    method: 'PATCH',
    noResBody: true,
    body: {
      holdings,
    },
  });

export const apiPortfolioProposalsPerformanceGet = (
  proposalId,
  { benchmarkId, yearsTag, compareIds, portfolioId }
) => {
  let startDate;
  if (yearsTag) {
    startDate = getStartAndEndDateByTag(yearsTag).startDate;
  }

  return userContext.apiCall({
    url: `/portfolio-proposals/${proposalId}/performances`,
    qs: {
      compareProposalIds: compareIds ?? '',
      benchmarkId,
      startDate,
      portfolioId: portfolioId ?? '',
    },
  });
};

export const apiPortfolioProposalsPatch = (proposalId, { ownerId, accepted, published, name }) => {
  return userContext.apiCall({
    url: `/portfolio-proposals/${proposalId}`,
    method: 'PATCH',
    noResBody: true,
    body: {
      portfolioProposalId: proposalId,
      name,
      ownerId, // -> userId
      accepted,
      published,
    },
  });
};

export const apiPortfolioProposalMaxDrawdownGet = ({
  proposalId,
  startDate,
  endDate,
  benchmarkId,
  samplingInterval,
}) =>
  userContext.apiCall({
    url: `/portfolio-proposals/${proposalId}/max-drawdown`,
    qs: { startDate, endDate, benchmarkIndexId: benchmarkId, samplingInterval },
  });
